import React, { } from 'react'

import {
  NotificationsPage as NotificationsPageCore
} from 'lib-core'
import styled from 'styled-components'
import { NoSsr } from '@material-ui/core'

import ErrorPanel from 'components/ErrorPanel'
import PleaseWait from 'components/PleaseWait'




const LoadingPlaceholder = () => <PleaseWait i18nKey="general.loading" />


const NotificationsPage = () => {

  return (
    <NoSsr>
      <NotificationsPageCore empty={<NoNotifications />} waiting={<LoadingPlaceholder />} error={ErrorPanel} />
    </NoSsr>

  )
}

const NoNotifications = () => (
  <PleaseWait i18nKey="posts.empty_list_placeholder" />
)


export default NotificationsPage
